import { inject } from '@angular/core';
import { CanMatchFn, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthStore } from 'src/core/stores';

export const adminGuard: CanMatchFn = ():
  | Observable<boolean | UrlTree>
  | Promise<boolean | UrlTree>
  | boolean
  | UrlTree => {
  const authStore = inject(AuthStore);

  return authStore.isAdmin();
};
